<template>
  <!--        style = "min-height: 100px; background: url('image/slider0.jpg') top center fixed; background-size: cover;  "-->
  <section class=" p-0 w-100  bg-light mt-2 mb-2 shadow">
    <section class="row pt-2 pb-2 m-0">
      <section class="col-12 py-4 px-5">

        <p class="h5 mt-4"> فراخوان جذب نیروی انسانی</p>
        <p style="text-align: justify">
          تهران آیلتس در نظر دارد به دلیل رفاه حال زبان آموزان عزیز و البته شرایط ویروس کرونا ، با تاکید بر آموزش
          آنلاین و افزایش تعداد آموزگاران
          این مجموعه، در حفظ رفاه و سلامتی زبان آموزان عزیز کوشیده، و امکان اموزش آنلاین بدون ایجاد اخلال در
          زمانبندی را میسر کند.
          از آموزگاران عزیزی که تمایل ب همکاری با مجموعه تهران آیلتس را دارند، خواهشمندیم اطلاعات خود را از بخش
          <a href="#">استخدام</a> برای ما ارسال فرمایند تا در اسرع وقت با آنها تماس بگیریم.
        </p>
      </section>
    </section>

  </section>
</template>

<script>
export default {
  name: "Invite"
}
</script>

<style scoped>

</style>